import type { Track } from "@similarweb/tracking-provider";

import { allTrackers } from "app/services/track/track";

function createTabbedPageContentTrackingService(track: Track) {
    return {
        trackSelectTab(tabName: string) {
            track("table", "click", `switch tab/${tabName}`);
        },
    };
}

export default createTabbedPageContentTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));
